<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="chevron-down">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M3.54635 7.39669C3.74161 7.20143 4.05819 7.20143 4.25346 7.39669L12.3999 15.5431L20.5463 7.39669C20.7416 7.20143 21.0582 7.20143 21.2535 7.39669C21.4487 7.59195 21.4487 7.90854 21.2535 8.1038L12.7535 16.6038C12.5582 16.7991 12.2416 16.7991 12.0463 16.6038L3.54635 8.1038C3.35109 7.90854 3.35109 7.59195 3.54635 7.39669Z" fill="#212328"/>
</g>
</svg>
